import React from 'react'
import CMSMenuWithLayout from './CMSMenuWithLayout';
import Img from '../../assets/images/background/banner-image-2.jpg'

function Menufour() {
  return (
    <CMSMenuWithLayout
      categoryFilter="coffee-tea"
      title="COFFEE & BEVERAGES"
      subtitle="Perfect for Any Time"
      bannerImage={Img}
      showOffers={false}
      showReservation={true}
    />
  )
}

export default Menufour